"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownDivider = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 0;\n  padding-top: ", ";\n  margin-top: ", ";\n  border-top: ", " ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DropdownDivider = (0, _styledComponents.default)(_styledBaseComponents.Div)(_templateObject(), function (props) {
  return (0, _styledConfig.getPadding)(props, 'dropdownDivider', 'top');
}, function (props) {
  return (0, _styledConfig.getMargin)(props, 'dropdownDivider', 'top');
}, function (props) {
  return (0, _styledConfig.getBorder)(props, 'dropdownDivider', 'default');
}, function (props) {
  return (0, _styledConfig.getColor)(props, 'dropdownDivider', 'borderTop');
});
exports.DropdownDivider = DropdownDivider;
DropdownDivider.defaultProps = {
  theme: _styledConfig.theme
};